import { LocalStore } from '@escon/utils';

LocalStore.setPrefix('layout-ms-example-');
console.log('LocalStore1', LocalStore);
/**
 * 设置本地缓存
 * @param name 缓存名称
 * @param value 缓存值
 */
const setLocalStore = (name, value) => {
  LocalStore.setLocalStore(name, value);
};

/**
 * 获取本地缓存
 * @param name
 * @returns
 */
const getLocalStore = (name) => {
  return LocalStore.getLocalStore(name);
};

/**
 * 清空本地缓存
 * @param name
 * @returns
 */
const clearLocalStore = () => {
  LocalStore.clearLocalStore();
};

export { setLocalStore, getLocalStore, clearLocalStore };
